// extracted by mini-css-extract-plugin
export default {"lastUpdated":"lastUpdated---TNa9Z"};